<app-ph-cropper #phCropper (phCropperChange)="findCorrectPhUpload($event)"></app-ph-cropper>

<div class="page project" [ngClass]="{'content-hidden': editMode && !editProject}">
  <div class="container">
    <div class="page__header flex-align-center flex flex-justify-between">
      <div>
        <h1 class="title title--bold" *ngIf="!editMode">{{ 'PROJECT.new_project' | translate }}</h1>
        <h1 class="title title--bold" *ngIf="editMode && editProject && !editProject.from_event">
          {{ 'PROJECT.edit_project' | translate }}
        </h1>
        <h1 class="title title--bold" *ngIf="editMode && editProject && editProject.from_event">
          {{ 'PROJECT.convert_to_project' | translate }}
        </h1>
        <a
          [routerLink]="['/' + RoutesPath.default.faq]"
          [fragment]="'good-project'"
          class="text--primary-light"
          target="_blank"
          >{{ 'PROJECT.good_practice' | translate }}</a
        >
      </div>
      <div class="project-control">
        <button
          class="btn btn--outline btn--md btn--primary"
          [disabled]="disabledDraft"
          (click)="createProject('draft')"
        >
          {{ 'PROJECT.save_to_drafts' | translate }}
        </button>
        <!-- if email is activated -->
        <button
          class="btn btn--primary btn--md"
          [disabled]="disabled"
          *ngIf="+storage.user.is_active === 1"
          (click)="createProject('publish')"
        >
          {{ 'PROJECT.publish' | translate }}
        </button>
        <!-- if email is not activated and user is normal-->
        <button
          class="btn btn--primary btn--md"
          [disabled]="disabled"
          *ngIf="+storage.user.is_active === 2 && storage.user.type === 'normal'"
          (click)="createProject('publish')"
        >
          {{ 'PROJECT.publish' | translate }}
        </button>
        <!-- if email is not activated and user is legal-->
        <button
          class="btn btn--primary btn--md"
          [disabled]="disabled"
          *ngIf="+storage.user.is_active === 2 && storage.user.type === 'legal'"
          (click)="createProject('draft')"
        >
          {{ 'PROJECT.publish' | translate }}
        </button>
      </div>
    </div>
    <div class="page__content">
      <app-ph-collapse
        [title]="'PROJECT.primary_information' | translate"
        [open]="true"
        class="project-new__sidebar card card--white card--shadow"
      >
        <p [innerHTML]="'PROJECT.preview_image' | translate"></p>
        <app-ph-upload
          styletype="primary"
          class="upload-img-sidebar"
          [correctForm]="formImg"
          [formDataFile]="true"
          [required]="true"
          (phUploadSuccess)="addToCropper($event)"
          [checkTags]="true"
          [requiredTags]="false"
          (phUploadSuccessOptions)="updateImagesDataTags($event)"
          #previewImg
          name="previewImg"
        ></app-ph-upload>
        <app-ph-input
          [placeholder]="'PROJECT.project_title' | translate"
          [validation]="'requiredtrim'"
          type="text"
          name="name"
          [correctForm]="form"
          [showRequired]="true"
        ></app-ph-input>
        <app-ph-input
          [placeholder]="'PROJECT.country' | translate"
          [validation]="'required'"
          type="select"
          bindValue="code"
          name="country"
          [showRequired]="true"
          [selectArray]="countries"
          bindLabel="name"
          [correctForm]="form"
        ></app-ph-input>
        <app-ph-input
          [placeholder]="'PROJECT.project_category' | translate"
          [validation]="'required'"
          type="select"
          [maxSelectedItems]="3"
          bindValue="id"
          [selectMultiple]="true"
          name="categories"
          [showRequired]="true"
          [selectArray]="categories"
          [initValue]="isWcd ? [28] : null"
          bindLabel="name"
          [correctForm]="form"
        ></app-ph-input>
        <app-ph-input
          [placeholder]="'PROJECT.project_range' | translate"
          [validation]="'required'"
          type="select"
          bindValue="value"
          name="days_to_end"
          [showRequired]="true"
          [searchable]="false"
          [initValue]="90"
          [selectArray]="range"
          bindLabel="name"
          [correctForm]="form"
        ></app-ph-input>
        <app-ph-input
          [placeholder]="'PROJECT.when_pickup_trash' | translate"
          [validation]="'required'"
          type="datepicker"
          [datepickerReadOnly]="false"
          [searchable]="false"
          name="end_job_date"
          (phInputChange)="checkWithDateImgAfter($event)"
          [correctForm]="form"
        ></app-ph-input>
        <div *ngIf="editMode && editProject && editProject.organization" class="project__organization">
          <span>{{ 'PROJECT.organization' | translate }}</span>
          <span class="project__organization--name">{{ editProject.organization.name }}</span>
        </div>
        <!-- <div *ngIf="editMode && !editProject.organization || !editMode">
          <p>{{'EVENT.event_organisation_help' | translate}}</p>
          <app-ph-input [placeholder]="'EVENT.pick_organisation' | translate"
                        [validation]="'empty'"
                        type="select"
                        bindValue="id"
                        name="organization"
                        [selectArray]="organisations"
                        bindLabel="name"
                        [correctForm]="form"></app-ph-input>
        </div> -->
      </app-ph-collapse>
      <div class="project-new__main card card--white card--shadow">
        <app-ph-tabset #tabsetCreate>
          <app-ph-tab [title]="'PROJECT.photo' | translate" name="photo" [active]="true">
            <app-photos
              [correctForm]="formImg"
              [correctFormDesc]="form"
              (imagesData)="updateImagesDataTags($event)"
              (newProjectCreateData)="setProjectCreateData($event)"
            ></app-photos>
          </app-ph-tab>
          <app-ph-tab [title]="'PROJECT.description' | translate" name="description">
            <app-description
              #descriptionSection
              *ngIf="(!editMode || editProject)"
              [formTrash]="formTrash"
              [editMode]="editMode && editProject"
              [editProject]="editProject"
              [notAddedBags]="notAddedBags"
              [bags]="editMode && editProject ? editProject.bags : []"
              [correctForm]="form"
            ></app-description>
          </app-ph-tab>
        </app-ph-tabset>
      </div>
    </div>
    <div class="limpa__content">
      <button
        class="btn btn--outline btn--md btn--primary"
        [disabled]="disabled"
        *ngIf="storage.getLang() === 'pt'"
        (click)="openLimpaForm()"
      >
        {{ 'PROJECT.fill_limpa_form' | translate }}
      </button>
    </div>

    <p-dialog
      [(visible)]="displayLoadingProjectModal"
      [dismissableMask]="true"
      [modal]="true"
      (onHide)="displayLoadingProjectModal = false; clearCounterLoading()"
    >
      <div style="padding: 40px 80px">
        <div
          class="modal__wrapper"
          *ngIf="counterLoading !== mustLoad && counterLoading < mustLoad"
        >
          <div *ngIf="typeProject === 'publish'">
            <div class="modal__title">{{ 'PROJECT.is_publishing' | translate }}</div>
            <div class="modal__description">
              {{ 'PROJECT.take_few_minutes' | translate }}
            </div>
          </div>
          <div *ngIf="typeProject === 'draft'">
            <div class="modal__title">{{ 'PROJECT.is_saving' | translate }}</div>
            <div class="modal__description">
              {{ 'PROJECT.take_few_seconds' | translate }}
            </div>
          </div>
          <div class="loading__images">
            <div class="loading__images--amount">
              {{ counterLoading }} {{ 'PROJECT.from' | translate }} {{ mustLoad }}
            </div>
            <div class="loading__images--bar">
              <div
                class="loading__images--bar-progress-line"
                [style.width]="projectStatusLoader"
              ></div>
            </div>
            <div class="loading__images--progress">
              {{ projectStatusLoader }}
            </div>
          </div>
        </div>
        <div class="modal__wrapper" *ngIf="counterLoading === mustLoad && counterLoading > 0">
          <div class="modal__title modal__title--lg text--green-light">
            {{ 'PROJECT.upload_success' | translate }}
          </div>
          <div class="modal__description text--dark text--bold" *ngIf="typeProject === 'publish'">
            {{ 'PROJECT.project_is_published' | translate }}
          </div>
          <div class="modal__description text--dark text--bold" *ngIf="typeProject === 'draft'">
            {{ 'PROJECT.project_is_saved' | translate }}
          </div>
          <div class="modal__icon modal__icon--success">
            <img
              src="assets/img/icons/check.svg"
              [alt]="'PROJECT.project_is_published' | translate"
            />
          </div>
        </div>
        <div
          class="modal__wrapper"
          *ngIf="counterLoading === mustLoad && mustLoad === 0 && typeProject === 'draft'"
        >
          <div class="modal__title modal__title--lg text--green-light">
            {{ 'PROJECT.upload_success' | translate }}
          </div>
          <div class="modal__description text--dark text--bold">
            {{ 'PROJECT.project_is_saved' | translate }}
          </div>
          <div class="modal__icon modal__icon--success">
            <img
              src="assets/img/icons/check.svg"
              [alt]="'PROJECT.project_is_published' | translate"
            />
          </div>
        </div>
      </div>
    </p-dialog>
    <app-additional-info
      #additionalInfo
      (additionalClose)="unlockButton()"
      (additionalSuccess)="createProject('publish')"
    ></app-additional-info>

    <p-dialog
      [(visible)]="displayFullYearModal"
      [dismissableMask]="true"
      [modal]="true"
      (onHide)="displayFullYearModal = false"
    >
      <div style="padding: 40px 80px">
        <div class="modal__wrapper">
          <div class="modal__title">{{ 'PROJECT.cannot_add_project' | translate }}</div>
          <div
            class="modal__description"
            [innerHTML]="'PROJECT.cannot_add_project_desc' | translate"
          ></div>
          <div class="text--center">
            <a
              [routerLink]="['/' + RoutesPath.default.faq + '/full-year']"
              class="text--primary-light text--center text--decorated"
              target="_blank"
              >{{ 'PROJECT.why_should_have_18_years' | translate }}</a
            >
          </div>
          <div class="modal__actions">
            <button
              class="btn btn--outline btn--default btn--md"
              (click)="displayFullYearModal = false; unlockButton()"
            >
              {{ 'PROJECT.back' | translate }}
            </button>
          </div>
        </div>
      </div>
    </p-dialog>
  </div>
</div>

<ng-template>
  <app-ph-loader [show]="editMode && !editProject" [static]="true"></app-ph-loader>
</ng-template>
